// © 2026 Holmes Computer Consultants. All rights reserved. -- www.holmesconsultants.com
/** Explicit authored lamp finish, independent of its fixed or moving ownership frame. */
export function componentLampKey(name:string):'light'|'bumperLight'|'targetLight'|'kickerLight'|'rolloverLight'|undefined {
  const marker='.component.authored.',at=name.indexOf(marker)
  if(at<0)return undefined
  const key=name.slice(at+marker.length)
  return key==='light'||key==='bumperLight'||key==='targetLight'||key==='kickerLight'||key==='rolloverLight'?key:undefined
}
